export default __webpack_public_path__ + "static/O0264-323addc50c835430e82d6891acc1b3c3.png";